// extracted by mini-css-extract-plugin
module.exports = {"submit":"Code_submit__2mcvA"};